import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana34Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1468_42592)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("24"))}
        fill={getFillByLot(24, selected, lands)}
        d="M523.996 239.767L530.205 267.085L484.26 280.744L474.326 242.25C479.293 240.594 492.456 236.538 505.37 233.558C518.284 230.578 523.168 236.456 523.996 239.767Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        fill={getFillByLot(1, selected, lands)}
        d="M435.835 250.941L474.329 242.249L484.263 280.743L438.318 293.16C436.663 287.366 432.855 273.789 430.868 265.842C428.881 257.895 433.352 252.596 435.835 250.941Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("23"))}
        fill={getFillByLot(23, selected, lands)}
        d="M541.385 305.579L530.209 267.085L484.265 280.744L495.44 319.239L541.385 305.579Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        fill={getFillByLot(2, selected, lands)}
        d="M448.254 331.655L438.32 293.16L484.265 280.743L494.199 317.995L448.254 331.655Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        fill={getFillByLot(3, selected, lands)}
        d="M460.669 370.151L448.252 331.656L495.439 317.997L506.614 355.25L460.669 370.151Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        fill={getFillByLot(22, selected, lands)}
        d="M552.557 342.831L541.381 305.578L495.437 319.237L507.854 358.973L552.557 342.831Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        fill={getFillByLot(4, selected, lands)}
        d="M473.087 408.645L460.67 370.151L506.615 355.25L519.032 393.744L473.087 408.645Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("21"))}
        fill={getFillByLot(21, selected, lands)}
        d="M564.98 381.326L552.562 342.832L507.859 358.975L520.277 396.227L564.98 381.326Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        fill={getFillByLot(5, selected, lands)}
        d="M486.746 448.381L473.087 408.645L519.032 393.744L531.449 430.996L486.746 448.381Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("20"))}
        fill={getFillByLot(20, selected, lands)}
        d="M577.393 418.579L564.976 381.326L520.272 396.227L532.69 435.963L577.393 418.579Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        fill={getFillByLot(6, selected, lands)}
        d="M500.408 486.873L486.749 448.379L531.452 430.994L546.353 468.247L500.408 486.873Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        fill={getFillByLot(19, selected, lands)}
        d="M592.297 454.59L577.396 418.579L533.935 435.964L547.594 471.974L592.297 454.59Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        fill={getFillByLot(7, selected, lands)}
        d="M515.308 524.128L500.407 486.875L546.352 468.249L560.011 504.26L515.308 524.128Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        fill={getFillByLot(18, selected, lands)}
        d="M607.197 490.6L592.296 454.589L547.593 471.973L562.494 510.468L607.197 490.6Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        fill={getFillByLot(8, selected, lands)}
        d="M531.449 561.381L515.307 524.129L560.01 504.261L576.152 540.272L531.449 561.381Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        fill={getFillByLot(17, selected, lands)}
        d="M622.095 526.612L607.194 490.602L562.491 510.47L578.634 546.48L622.095 526.612Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        fill={getFillByLot(9, selected, lands)}
        d="M548.834 597.391L531.449 561.38L576.152 540.271L592.295 576.281L548.834 597.391Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        fill={getFillByLot(16, selected, lands)}
        d="M638.244 561.379L622.101 526.61L578.64 546.478L596.024 582.489L638.244 561.379Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        fill={getFillByLot(10, selected, lands)}
        d="M567.464 634.643L548.838 597.39L592.299 576.28L610.925 612.291L567.464 634.643Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        fill={getFillByLot(15, selected, lands)}
        d="M656.867 597.391L638.241 561.38L596.021 582.49L614.648 619.742L656.867 597.391Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        fill={getFillByLot(11, selected, lands)}
        d="M586.083 670.654L567.457 634.644L610.918 612.292L629.545 647.061L586.083 670.654Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        fill={getFillByLot(14, selected, lands)}
        d="M675.491 632.162L656.865 597.393L614.646 619.744L633.272 654.513L675.491 632.162Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        fill={getFillByLot(13, selected, lands)}
        d="M689.148 656.995L675.489 632.16L633.27 654.511L650.654 686.797L680.456 676.863C691.384 673.883 690.804 662.376 689.148 656.995Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        fill={getFillByLot(12, selected, lands)}
        d="M602.494 698.345L586.085 670.655L629.546 647.062L650.656 686.798L612.276 701.723C608.628 703.142 604.49 701.713 602.494 698.345Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1468_42592"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1468_42592"
            transform="matrix(0.00170327 0 0 0.00225808 -2.4998 -0.638119)"
          />
        </pattern>
        <image
          id="image0_1468_42592"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
